<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Fatura İşçilik Tablosu</v-toolbar-title>
      <v-spacer />
      <v-btn flat color="primary" to="/admin/invoice-labor/held">Kesilmeyen Faturalar</v-btn>
      <v-btn icon @click="yenile">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout row wrap class="px-3 pb-2">
      <v-flex v-for="t in durumlar" :key="t.tenantId" xs12 md6 class="pa-2">
        <v-card :class="{ 'sirket-secili': t.tenantId === tenantId }">
          <v-card-title class="pb-0">
            <div class="title">{{ t.tenantName }}</div>
            <v-spacer />
            <v-chip small :color="t.active ? 'green' : 'grey'" text-color="white">
              {{ t.active ? 'Yeni hesap' : 'Eski formül' }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-switch
              :input-value="t.active"
              :label="t.active ? 'Açık: fatura yeni hesapla kesiliyor' : 'Kapalı: fatura eski formülle kesiliyor'"
              color="green"
              hide-details
              :loading="anahtarYukleniyor === t.tenantId"
              @change="anahtarDegistir(t)"
            />
            <div v-if="t.tenantId !== tenantId" class="mt-3 grey--text text--darken-1">
              Idefix faturasında altın has fiyatından, komisyon oranla, işçilik kalan tutar olarak yazılır.
              Idia faturaları eski hesapla devam eder. Bu şirket için işçilik tablosu kullanılmaz.
            </div>
            <div v-else class="mt-3">
              Aktif ürünlerde: <b>{{ t.girilen }}</b> girildi · <b :class="t.eksik ? 'red--text' : ''">{{ t.eksik }}</b> eksik
            </div>
            <div>
              <span v-if="t.active">Faturası bekleyen sipariş:</span>
              <span v-else>Anahtar açılırsa bekleyecek sipariş:</span>
              <router-link to="/admin/invoice-labor/held"><b :class="t.bekleyen ? 'red--text' : ''">{{ t.bekleyen }}</b></router-link>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-alert :value="true" type="info" outline class="mx-3">
      Yazılan tutar <b>KDV DAHİL</b> işçiliktir. <b>Bilezik ve 24 ayar altında 1 gram</b>, diğer ürünlerde <b>1 adet</b> içindir.
      Örnek: 10 gr bilezik için <b>30</b> yazarsanız faturada işçilik <b>300 ₺</b> olur (250,00 ₺ + 50,00 ₺ KDV).
      Anahtar açıkken faturada altın <b>gram × milyem × (has fiyatı + 50)</b>, işçilik bu tablodan, komisyon da kalan tutar olarak yazılır.
      Tutarı silmek için kutuyu boşaltın.
    </v-alert>

    <v-card class="mx-3 mt-3">
      <v-card-title class="pb-0">
        <div class="subheading font-weight-medium">{{ seciliSirketAdi }} ürünleri</div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md4 class="px-2">
            <v-text-field v-model="arama" label="Ürün adı / SKU ara (bilezik, çeyrek...)" prepend-icon="search" clearable />
          </v-flex>
          <v-flex xs12 md3 class="px-2">
            <v-select v-model="kategori" :items="kategoriSecenekleri" label="Kategori" clearable />
          </v-flex>
          <v-flex xs6 md2 class="px-2">
            <v-select v-model="durum" :items="durumSecenekleri" label="Ürün durumu" />
          </v-flex>
          <v-flex xs6 md3 class="px-2">
            <v-select v-model="iscilikFiltre" :items="iscilikSecenekleri" label="İşçilik" />
          </v-flex>
        </v-layout>
        <div v-if="idFiltresi.length" class="px-2">
          <v-chip close color="orange" text-color="white" @input="idFiltresiTemizle">
            Sadece faturası bekleyen siparişlerdeki {{ idFiltresi.length }} ürün gösteriliyor
          </v-chip>
        </div>

        <v-layout row wrap align-center class="px-2 mt-2">
          <v-btn small outline color="primary" :disabled="!filtrelenmis.length" @click="filtrediHepsiniSec">
            Filtredekilerin hepsini seç ({{ filtrelenmis.length }})
          </v-btn>
          <v-btn small flat :disabled="!secili.length" @click="secili = []">Seçimi temizle</v-btn>
          <v-spacer />
          <span class="mr-3">{{ secili.length }} ürün seçili</span>
          <v-btn color="primary" :disabled="!secili.length" @click="topluAc">Seçilenlere işçilik yaz</v-btn>
        </v-layout>
      </v-card-text>

      <v-data-table
        :headers="headers"
        :items="filtrelenmis"
        item-key="id"
        :rows-per-page-items="[50, 100, { text: 'Hepsi', value: -1 }]"
        :loading="yukleniyor"
        class="elevation-0"
      >
        <template v-slot:items="props">
          <td class="px-2">
            <v-checkbox
              :input-value="seciliMi(props.item.id)"
              hide-details
              class="mt-0 pt-0"
              @change="secimDegistir(props.item.id)"
            />
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.sku }}</td>
          <td>{{ props.item.categoryName || '—' }}</td>
          <td class="text-xs-right">{{ props.item.gram }}</td>
          <td class="text-xs-right">{{ props.item.purity || '' }}</td>
          <td>
            <v-chip small :color="props.item.state ? 'green lighten-4' : 'grey lighten-3'">
              {{ props.item.state ? 'Aktif' : 'Pasif' }}
            </v-chip>
          </td>
          <td class="iscilik-hucre">
            <v-text-field
              :key="props.item.id + '-' + (surum[props.item.id] || 0)"
              :value="kutuDegeri(props.item)"
              placeholder="Girilmemiş"
              :suffix="props.item.gramBasi ? '₺ / gr' : '₺'"
              single-line
              hide-details
              :background-color="props.item.invoiceLaborCost ? '' : 'red lighten-5'"
              :loading="kaydediliyor[props.item.id]"
              @change="v => tekKaydet(props.item, v)"
              @keyup.enter="$event.target.blur()"
            />
          </td>
          <td class="text-xs-right grey--text text--darken-1">
            <template v-if="props.item.invoiceLaborCost">
              {{ para(kdvHaric(adetTutari(props.item))) }} ₺
              <div v-if="props.item.gramBasi" class="caption">{{ props.item.gram }} gr × {{ para(props.item.invoiceLaborCost) }}</div>
            </template>
            <template v-else>—</template>
          </td>
        </template>
        <template v-slot:no-data>
          <div class="text-xs-center pa-3">Filtreye uyan ürün yok.</div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="topluDialog" max-width="520">
      <v-card>
        <v-card-title class="headline">Seçilen {{ secili.length }} ürüne işçilik yaz</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="topluTutar"
            label="KDV DAHİL işçilik (bilezik ve 24 ayarda 1 gram, diğerlerinde 1 adet için)"
            suffix="₺"
            autofocus
            :error-messages="topluHata"
            @keyup.enter="topluKaydet"
          />
          <div v-if="topluSayi">
            Faturada 1 adet / 1 gram için: <b>{{ para(kdvHaric(topluSayi)) }} ₺</b> işçilik + <b>{{ para(kdv(topluSayi)) }} ₺</b> KDV
            = <b>{{ para(topluSayi) }} ₺</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="red" :disabled="topluKayit" @click="topluSil">Seçilenlerin işçiliğini sil</v-btn>
          <v-spacer />
          <v-btn flat @click="topluDialog = false">Vazgeç</v-btn>
          <v-btn color="primary" :loading="topluKayit" @click="topluKaydet">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import invoiceLaborApi from "@/api/invoiceLabor";

export default {
  data() {
    return {
      durumlar: [],
      tenantId: null,
      urunler: [],
      yukleniyor: false,
      anahtarYukleniyor: null,
      kaydediliyor: {},
      surum: {},
      arama: "",
      kategori: null,
      durum: "aktif",
      iscilikFiltre: "hepsi",
      idFiltresi: [],
      secili: [],
      topluDialog: false,
      topluTutar: "",
      topluHata: "",
      topluKayit: false,
      durumSecenekleri: [
        { text: "Aktif", value: "aktif" },
        { text: "Pasif", value: "pasif" },
        { text: "Hepsi", value: "hepsi" }
      ],
      iscilikSecenekleri: [
        { text: "Hepsi", value: "hepsi" },
        { text: "Girilmemiş", value: "girilmemis" },
        { text: "Girilmiş", value: "girilmis" }
      ],
      headers: [
        { text: "", value: "secim", sortable: false, width: "40" },
        { text: "Ürün", value: "name" },
        { text: "SKU", value: "sku" },
        { text: "Kategori", value: "categoryName" },
        { text: "Gram", value: "gram", align: "right" },
        { text: "Ayar", value: "purity", align: "right" },
        { text: "Durum", value: "state" },
        { text: "İşçilik — KDV DAHİL", value: "invoiceLaborCost", width: "200" },
        { text: "1 adet, KDV hariç", value: "kdvHaric", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    seciliSirketAdi() {
      const t = this.durumlar.find(d => d.tenantId === this.tenantId);
      return t ? t.tenantName : "";
    },
    kategoriSecenekleri() {
      const adlar = [...new Set(this.urunler.map(u => u.categoryName || "Kategorisiz"))];
      return adlar.sort((a, b) => a.localeCompare(b, "tr"));
    },
    filtrelenmis() {
      const q = (this.arama || "").toLocaleLowerCase("tr-TR").trim();
      const idler = new Set(this.idFiltresi);
      return this.urunler.filter(u => {
        if (idler.size && !idler.has(u.id)) return false;
        if (!idler.size && this.durum === "aktif" && !u.state) return false;
        if (!idler.size && this.durum === "pasif" && u.state) return false;
        if (this.kategori && (u.categoryName || "Kategorisiz") !== this.kategori) return false;
        if (this.iscilikFiltre === "girilmemis" && u.invoiceLaborCost) return false;
        if (this.iscilikFiltre === "girilmis" && !u.invoiceLaborCost) return false;
        if (q) {
          const metin = `${u.name || ""} ${u.sku || ""}`.toLocaleLowerCase("tr-TR");
          if (!metin.includes(q)) return false;
        }
        return true;
      });
    },
    topluSayi() {
      const v = this.tutarOku(this.topluTutar);
      return v && v > 0 ? v : null;
    }
  },
  watch: {
    tenantId() {
      this.secili = [];
      this.urunleriGetir();
    }
  },
  created() {
    this.idFiltresi = (this.$route.query.ids || "").split(",").map(Number).filter(Boolean);
    this.durumlariGetir();
    this.tenantId = 1;
  },
  methods: {
    async durumlariGetir() {
      try {
        const res = await invoiceLaborApi.status();
        this.durumlar = res.data;
      } catch (e) {
        this.$store.commit("SET_MESSAGE", "İşçilik durumu okunamadı.");
      }
    },
    async urunleriGetir() {
      if (!this.tenantId) return;
      this.yukleniyor = true;
      try {
        const res = await invoiceLaborApi.products(this.tenantId);
        this.urunler = res.data;
      } catch (e) {
        this.$store.commit("SET_MESSAGE", "Ürünler okunamadı.");
      } finally {
        this.yukleniyor = false;
      }
    },
    yenile() {
      this.durumlariGetir();
      this.urunleriGetir();
    },
    idFiltresiTemizle() {
      this.idFiltresi = [];
      this.$router.replace({ query: {} });
    },
    async anahtarDegistir(t) {
      const yeni = !t.active;
      const kapsam = t.tenantId === this.tenantId
        ? "İşçiliği, gramı ya da has fiyatı eksik olan, veya komisyonu eksiye düşen siparişlerin"
        : "Idia faturaları eski hesapla devam edecek. Idefix'te gramı ya da has fiyatı eksik olan, veya işçiliği eksiye düşen siparişlerin";
      const mesaj = yeni
        ? `${t.tenantName} faturaları artık yeni hesapla kesilecek: altın has fiyatından hesaplanacak.\n\n` +
          `${kapsam} faturası KESİLMEYECEK ve "Kesilmeyen Faturalar" ekranında görünecek.\n` +
          `Şu an bu durumda olan sipariş: ${t.bekleyen}\n\nAçılsın mı?`
        : `${t.tenantName} faturaları yeniden eski formülle kesilecek.\n\nKapatılsın mı?`;
      if (!window.confirm(mesaj)) {
        const eski = this.durumlar;
        this.durumlar = [];
        this.$nextTick(() => { this.durumlar = eski; });
        return;
      }
      this.anahtarYukleniyor = t.tenantId;
      try {
        await invoiceLaborApi.setStatus(t.tenantId, yeni);
      } catch (e) {
        this.$store.commit("SET_MESSAGE", "Anahtar değiştirilemedi.");
      } finally {
        this.anahtarYukleniyor = null;
        await this.durumlariGetir();
      }
    },
    seciliMi(id) {
      return this.secili.includes(id);
    },
    secimDegistir(id) {
      this.secili = this.seciliMi(id) ? this.secili.filter(x => x !== id) : [...this.secili, id];
    },
    filtrediHepsiniSec() {
      this.secili = [...new Set([...this.secili, ...this.filtrelenmis.map(u => u.id)])];
    },
    tutarOku(v) {
      let s = String(v == null ? "" : v).replace(/[₺\s]/g, "");
      if (!s) return null;
      if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
      const n = Number(s);
      return Number.isFinite(n) ? Math.round(n * 100) / 100 : NaN;
    },
    kdvHaric(v) {
      return Math.round((Math.round(v * 100) * 10) / 12) / 100;
    },
    kdv(v) {
      return (Math.round(v * 100) - Math.round(this.kdvHaric(v) * 100)) / 100;
    },
    para(n) {
      return Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    adetTutari(u) {
      const carpan = u.gramBasi ? u.gram : 1;
      return Math.round(u.invoiceLaborCost * carpan * 100) / 100;
    },
    kutuDegeri(u) {
      return u.invoiceLaborCost ? this.para(u.invoiceLaborCost) : "";
    },
    async kaydet(ids, tutar) {
      await invoiceLaborApi.setProducts(this.tenantId, ids, tutar);
      const set = new Set(ids);
      this.urunler = this.urunler.map(u => (set.has(u.id) ? { ...u, invoiceLaborCost: tutar } : u));
      this.durumlariGetir();
    },
    async tekKaydet(u, v) {
      const tutar = this.tutarOku(v);
      if (Number.isNaN(tutar) || (tutar !== null && tutar <= 0)) {
        this.$store.commit("SET_MESSAGE", `"${v}" geçerli bir tutar değil. 0'dan büyük bir sayı yazın, silmek için kutuyu boşaltın.`);
        this.kutuyuSifirla(u.id);
        return;
      }
      if (tutar === (u.invoiceLaborCost || null)) return;
      this.$set(this.kaydediliyor, u.id, true);
      try {
        await this.kaydet([u.id], tutar);
      } catch (e) {
        this.$store.commit("SET_MESSAGE", `${u.name} için işçilik kaydedilemedi.`);
        this.kutuyuSifirla(u.id);
      } finally {
        this.$set(this.kaydediliyor, u.id, false);
      }
    },
    kutuyuSifirla(id) {
      this.$set(this.surum, id, (this.surum[id] || 0) + 1);
    },
    topluAc() {
      this.topluTutar = "";
      this.topluHata = "";
      this.topluDialog = true;
    },
    async topluKaydet() {
      const tutar = this.tutarOku(this.topluTutar);
      if (!tutar || Number.isNaN(tutar) || tutar <= 0) {
        this.topluHata = "0'dan büyük bir tutar yazın.";
        return;
      }
      if (!window.confirm(`${this.secili.length} ürünün işçiliği 1 adet (bilezik ve 24 ayarda 1 gram) için KDV DAHİL ${this.para(tutar)} ₺ olacak. Onaylıyor musunuz?`)) return;
      await this.topluUygula(tutar);
    },
    async topluSil() {
      if (!window.confirm(`${this.secili.length} ürünün işçiliği silinecek. Anahtar açıksa bu ürünleri içeren siparişlerin faturası kesilmez. Onaylıyor musunuz?`)) return;
      await this.topluUygula(null);
    },
    async topluUygula(tutar) {
      this.topluKayit = true;
      try {
        await this.kaydet(this.secili, tutar);
        this.topluDialog = false;
        this.secili = [];
      } catch (e) {
        const mesaj = e.response && e.response.data && e.response.data.message;
        this.topluHata = mesaj || "Kaydedilemedi.";
      } finally {
        this.topluKayit = false;
      }
    }
  }
};
</script>

<style scoped>
.sirket-secili {
  border: 2px solid #1976d2;
}
.iscilik-hucre {
  min-width: 180px;
}
</style>
